export default __webpack_public_path__ + "static/media/Seal of Privilege.0e600d63.jpg";